module.exports = __webpack_public_path__ + "static/bookmarks-33c1d1e4a9c3cdf7a5d28826ed1dff4c.png";